import React, {useState, useEffect} from 'react';

const SidebarLink = (props) => {
    const [active, setActive] = useState(false);
    const [trail, setTrail] = useState(false);
    const [open, setOpen] = useState(false);
    const [activeTrail, setActiveTrail] = useState(null);

    let path = window.location.pathname.replace(/\/$/g, '');

    const clickLink = (e) => {
        if(!props.followLink) {
            e.preventDefault();
            e.stopPropagation();
            if (props.href) {
              if (path != props.href) {
                docs.utils.loadMenuContent(e.target.id);
              }
              setActive(true);
            }
        }
        if(!props.followLink || (props.followLink && !props.href)) {
          toggleOpen(!open);
        }
    };

    const toggleOpen = (value) => {
        if (links.length) {
            setOpen(value);
        }
        if (value && props.parentToggleOpen) {
            props.parentToggleOpen(true);
        }
    };

    const addTrail = (id) => {
        setActiveTrail(id);
        props.parentAddTrail(id);
        setTrail(true);
        setActive(false);
    };

    const removeTrail = (id) => {
        if (activeTrail == id) {
            setActiveTrail(null);
            props.parentRemoveTrail(id);
            setTrail(false);
        }
    };

    useEffect(() => {
        if (path === props.href) {
            docs.utils.loadMenuContent(props.id);
            setActive(true);
            toggleOpen(true);
        }
        else {
            setActive(false);
        }
    }, []);

    useEffect(() => {
        if (active) {
            props.parentAddTrail(props.id);
        }
        else {
            props.parentRemoveTrail(props.id);
        }
    }, [active]);

    useEffect(() => {
        path = window.location.pathname.replace(/\/$/g, '');
        if (props.href !== path) {
            setActive(false);
        }
    }, [path]);

    let links = [];
    if (props.links.length) {
        props.links.forEach((link, index) => {
            let link_url = props.url + ('url_path' in link ? '/' + link.url_path : '');
            let link_href = 'url_path' in link ? link_url : null;
            let link_children = link.children ? link.children.slice() : [];
            links.push(
                    <SidebarLink key={link.id} id={link.id} url={link_url}
                                 name={link.display_name}
                                 links={link_children} href={link_href}
                                 parentToggleOpen={toggleOpen}
                                 parentAddTrail={addTrail}
                                 parentRemoveTrail={removeTrail}
                                 followLink={props.followLink}></SidebarLink>
            );
        });
    }

    return (
            <li>
                <a id={props.id} href={props.href}
                   className={`adskf__sidebar-link ${open ? 'open' : ''} ${active && props.href ? 'active' : ''} ${trail ? 'trail' : ''} ${links.length ? 'has-links' : ''}`}
                   onClick={clickLink} dangerouslySetInnerHTML={{__html: props.name}}></a>
                {links.length > 0 &&
                <ul>{links}</ul>
                }
            </li>
    );
};

export default SidebarLink;
